import { render, staticRenderFns } from "./modal_name.vue?vue&type=template&id=49208c8e&scoped=true"
import script from "./modal_name.vue?vue&type=script&lang=js"
export * from "./modal_name.vue?vue&type=script&lang=js"
import style0 from "./modal_name.vue?vue&type=style&index=0&id=49208c8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49208c8e",
  null
  
)

export default component.exports